import { render, staticRenderFns } from "./PccOrderCustomsProperties.vue?vue&type=template&id=97832efe&scoped=true&"
import script from "./PccOrderCustomsProperties.vue?vue&type=script&lang=js&"
export * from "./PccOrderCustomsProperties.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97832efe",
  null
  
)

export default component.exports